export default {
  orderSetting: {
    isLoading: false,
    data: {},
    status: null,
    error: false,
    errorMessage: null
  },
};
